import { render, staticRenderFns } from "./SendBat.vue?vue&type=template&id=2e1132be&scoped=true&"
import script from "./SendBat.vue?vue&type=script&lang=js&"
export * from "./SendBat.vue?vue&type=script&lang=js&"
import style0 from "./SendBat.vue?vue&type=style&index=0&id=2e1132be&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e1132be",
  null
  
)

export default component.exports